
import './index.less'
import React from 'react'
export default function NovelIfonCopy(props) {
  return (<div className={`NovelIfon`} style={{
    width: 375,
    opacity: 0.5
  }}>

    <div className={`NovelIfonBox`}>
      {!props.ifon.ifon.image.src ? null : <div className='NovelIfonBox_left'>
        <img className='img' src={props.ifon.ifon.image.src} />
      </div>}

      <div className='NovelIfonBox_right' dangerouslySetInnerHTML={{ __html: props.ifon.ifon.html }}>

      </div>
    </div>

  </div>)
}
console.log(React)
